import React from 'react'
import styles from './style.module.scss'
import EditorsPick from './editorsPick'
import F1Heading from '../F1Heading'
import PropTypes from 'prop-types'
import CustomLink from '@shared/components/customLink'
export function F1EditorsPick({ editorsData }) {
  return (
    <>
      <div className={styles.editorsLayout}>
        {editorsData?.map((news, i) => {
          return (
            <EditorsPick key={i} news={news} />
          )
        })}
      </div>
    </>
  )
}

F1EditorsPick.propTypes = {
  editorsData: PropTypes.array
}

export function HotStories({ news }) {
  return (
    <>
      <div className={styles.storiesLayout}>
        <F1Heading title={'Hot News'} />
        <div className={styles.HotStories}>
          {news?.map((news, i) => {
            return (
              <EditorsPick key={i} news={news} />
            )
          })}
        </div>
        <CustomLink href={'/formula-1'}>
          <button className={styles.readmoreBtn}>
            <span >
              {'Read More ->'}
            </span>
          </button>
        </CustomLink>
      </div>
    </>
  )
}

HotStories.propTypes = {
  news: PropTypes.array
}
